import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { superadminGuard } from './guards/superadmin.guard';
import { householdGuard } from './guards/household.guard';
import { defaultModuleGuard } from './guards/default-module.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'email/verify/check',
    loadComponent: () => import('./components/email-verification/email-verification.component').then(m => m.EmailVerificationComponent)
  },
  {
    path: 'email/verify/:id',
    loadComponent: () => import('./components/email-verification/email-verification.component').then(m => m.EmailVerificationComponent)
  },
  {
    path: 'password/request',
    loadComponent: () => import('./components/password-reset-request/password-reset-request.component').then(m => m.PasswordResetRequestComponent)
  },
  {
    path: 'password/reset/:id',
    loadComponent: () => import('./components/password-reset/password-reset.component').then(m => m.PasswordResetComponent)
  },
  {
    path: 'email-change-verify/:id',
    loadComponent: () => import('./components/email-change-verify/email-change-verify.component').then(m => m.EmailChangeVerifyComponent)
  },
  {
    path: '2fa/verify',
    loadComponent: () => import('./components/two-factor-verify/two-factor-verify.component').then(m => m.TwoFactorVerifyComponent)
  },
  {
    path: 'household/setup',
    canActivate: [authGuard],
    loadComponent: () => import('./components/finance/household-setup/household-setup.component').then(m => m.HouseholdSetupComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./components/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    children: [
      {
        path: 'dashboard',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'journal',
        loadComponent: () => import('./components/journal/journal-lock/journal-lock.component').then(m => m.JournalLockComponent),
        children: [
          {
            path: 'dashboard',
            loadComponent: () => import('./components/journal/journal-home/journal-home.component').then(m => m.JournalHomeComponent)
          },
          {
            path: '',
            loadComponent: () => import('./components/journal/journal-dashboard/journal-dashboard.component').then(m => m.JournalDashboardComponent)
          }
        ]
      },
      {
        path: 'goals',
        loadComponent: () => import('./components/goals/goals-dashboard/goals-dashboard.component').then(m => m.GoalsDashboardComponent)
      },
      {
        path: 'goals/dashboard',
        loadComponent: () => import('./components/goals/goals-home/goals-home.component').then(m => m.GoalsHomeComponent)
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () => import('./components/admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent)
      },
      {
        path: 'dev-tasks',
        canActivate: [superadminGuard],
        loadComponent: () => import('./components/admin/dev-tasks/dev-tasks.component').then(m => m.DevTasksComponent)
      },
      {
        path: 'finance',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/finance-dashboard/finance-dashboard.component').then(m => m.FinanceDashboardComponent)
      },
      {
        path: 'finance/transactions',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/transactions/transactions.component').then(m => m.TransactionsComponent)
      },
      {
        path: 'finance/capture',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/capture/capture.component').then(m => m.CaptureComponent)
      },
      {
        path: 'finance/categories',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/categories/categories.component').then(m => m.CategoriesComponent)
      },
      {
        path: 'finance/statistics',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/statistics/statistics.component').then(m => m.StatisticsComponent)
      },
      {
        path: 'finance/merchants',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/merchants/merchants.component').then(m => m.MerchantsComponent)
      },
      {
        path: 'finance/map',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/map/map.component').then(m => m.MapComponent)
      },
      {
        path: 'finance/budgets',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/budgets/budgets.component').then(m => m.BudgetsComponent)
      },
      {
        path: 'finance/recurring',
        canActivate: [householdGuard],
        loadComponent: () => import('./components/finance/recurring/recurring.component').then(m => m.RecurringComponent)
      },
      {
        path: '',
        canActivate: [defaultModuleGuard],
        pathMatch: 'full',
        children: []
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
